import React from 'react'
import { roadmapItems } from "../../../mock/roadmap"
import { Section } from "../../ui"
import TickSVG from '../../../assets/images/tick.svg'

import './roadmap.scss'

const RoadmapSection = () => {

    return (
        <Section variant="grey">
            <div className="roadmap">
                <h2 className="roadmap-title">Roadmap</h2>
                <ul className="roadmap-list">
                    {
                        roadmapItems.map(({percentage, description, isCompleted}, i) => (
                            <li className="item-wrapper" key={i}>
                                <span className="item-percentage" style={{textDecoration: isCompleted && 'line-through'}}>{percentage}</span>
                                <p className="item-description">{description}</p>
                                <span className="item-tick">{isCompleted && <img src={TickSVG}/>}</span>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </Section>
    )
}

export default RoadmapSection